<template>
  <div class="report-template">
    <header>
      <h2 class="report-label">Report</h2>
      <h3 class="report-name">{{ report.title }}</h3>
    </header>
    <table class="details-table">
      <tr>
        <th>
          Vettore
        </th>
        <td class="text-right">
          {{ report.vector_name }}
        </td>
      </tr>
      <tr>
        <th>
          Categoria
        </th>
        <td class="text-right">
          {{ report.category_name }}
        </td>
      </tr>
      <tr>
        <th>
          Totale consumi annui
        </th>
        <td class="text-right">
          {{ report.consumption }}
          <span v-if=" report.vector === 'ee'">kWh</span>
          <span v-if=" report.vector === 'gas'">m³</span>
        </td>
      </tr>
      <tr>
        <th>
          Totale costi annui
        </th>
        <td class="text-right">
          € {{ report.cost }}
        </td>
      </tr>
      <tr>
        <th>
          Indicatore
        </th>
        <td class="text-right">
          {{ report.indicator }}
        </td>
      </tr>
      <tr>
        <th>
          Valutazione
        </th>
        <td class="grade text-right" :class="'grade-'+report.grade">
          {{ report.grade_name }}
        </td>
      </tr>
    </table>

    <h2 class="section-title">Risultato delle analisi</h2>

    <p>Le informazioni di seguito riportate sono da intendersi puramente indicative e possono differire in modo
      rilevante da valutazioni basate sul reale stato e utilizzo degli edifici e degli impianti.</p>

    <h3 class="sub-title" v-if="report.vector === 'ee'">Energia elettrica</h3>
    <h3 class="sub-title" v-if="report.vector === 'gas'">Gas</h3>

    <table class="details-table">
      <tr>
        <td class="cell-padding">{{ report.overall_judgement }}</td>
        <td class="no-wrap bold surplus" v-if="report.surplus">
          + {{ report.surplus | formatCurrency }} <small>€/anno</small>
        </td>
      </tr>
      <tr class="surplus-mobile" v-if="report.surplus">
        <td class="no-wrap bold" colspan="2">
          <span>
            + {{ report.surplus | formatCurrency }} <small>€/anno</small>
          </span>
        </td>
      </tr>
    </table>

    <h2 class="section-title">1. Proposte migliorative</h2>

    <div class="section">
      <h3 class="sub-title">1.1. Monitoraggio consumi energetici</h3>

      <p>
        Misurare i consumi è il primo passo per il loro controllo e la loro riduzione. Soprattutto per le
        grandezze elettriche l’installazione di apparecchiature hardware e software per il controllo dei consumi
        è ormai una routine ed i costi sono irrisori. I dati presenti in letteratura indicano che
        l’installazione dei sistemi di monitoraggio portano ad un beneficio pari al 5% dei consumi annui.
      </p>
    </div>

    <div class="section">
      <h3 class="sub-title">1.2. Interventi di efficienza energetica</h3>


      <div v-for="(improvements, key) in report.improvements" :key="key">
        <h4 class="category-title">
          <span class="category-title-inner">{{ improvements.title }}</span>
          <a href="#" @click.prevent="more" class="more-btn">Scopri di più</a>
        </h4>
        <ol>
          <li v-for="(improvement, key) in improvements.items" :key="key">
            {{ improvement }}
          </li>
        </ol>
      </div>
    </div>

    <div class="section">
      <h3 class="sub-title">1.3. Buone pratiche</h3>

      <div v-for="(bestPractices, key) in report.best_practices" :key="key">
        <h4 class="subcategory-title">{{ bestPractices.title }}</h4>
        <ol>
          <li v-for="(bestPractice, key) in bestPractices.items" :key="key">
            {{ bestPractice }}
          </li>
        </ol>
      </div>
    </div>

    <div class="section">
      <h3 class="section-title">2. Link utili</h3>

      <div v-for="(links, key) in report.links" :key="key">
        <h4 class="category-title">{{ links.title }}</h4>
        <ul>
          <li v-for="(link, key) in links.items" :key="key">
            <a :href="link.url" rel="noopener" target="_blank">
              {{ link.title }}
            </a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {formatCurrency} from "@/helpers";

Vue.filter('formatCurrency', formatCurrency);

export default {
  props: ['report', 'moreAction'],
  methods: {
    more() {
      this.moreAction();
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/colors.scss";

/** Custom */
.report-container {
  padding: 10px 0;
  font-size: 14px;
  color: #121212;
}

.report-template header {
  background: #016B31;
  color: #fff;
  padding: 10px;
  margin-bottom: 30px;
}

.report-template table {
  border-collapse: collapse;
  border-spacing: 0;
}

.report-label {
  font-size: 12px;
  text-transform: uppercase;
  color: #bfe6d1;
  margin-bottom: 5px;
}

.report-name {
  font-size: 18px;
}

.report-template .details-table {
  width: 100%;
  border-bottom: 1px solid #eee;
  margin-bottom: 30px;
}

.report-template .details-table tr {
  border-top: 1px solid #eee;
}


.report-template th, .report-template td {
  padding: 10px 0;
  text-align: left;
  vertical-align: middle;
}

.report-template .details-table th {
  font-weight: bold;
}

.report-template .text-right {
  text-align: right;
}

.report-template .grade {
  text-transform: uppercase;
}

.report-template p {
  margin-bottom: 15px;
}

.grade-1 {
  color: #ff5238;
}

.grade-2 {
  color: #ff9c46;
}

.grade-3 {
  color: #ffdf35;
}

.grade-4 {
  color: #dbff38;
}

.grade-5 {
  color: #83ff33;
}

.bold {
  font-weight: bold;
}

.report-template .section {
  margin-bottom: 30px;
}

.report-template .section-title {
  font-size: 34px;
  color: #000;
  margin-bottom: 30px;
}

.report-template .sub-title {
  font-size: 28px;
  color: #000;
  margin-bottom: 15px;
}

.category-title {
  display: flex !important;
  justify-content: space-between;
}

.category-title-inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.report-template .category-title, .report-template .subcategory-title {
  font-weight: 800;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  display: block;
  padding: 5px;
  color: #016B31;
  font-size: 18px;
}

.report-template .subcategory-title {
  font-size: 18px;
}

.report-template ol, .report-template ul {
  margin-bottom: 15px;
}

.report-template ol li {
  margin-left: 20px;
}

.report-template ul li {
  margin-left: 20px;
}

.report-template .no-wrap {
  white-space: nowrap;
}

.report-template .cell-padding {
  padding: 10px;
}

.report-template .surplus, .report-template .surplus-mobile {
  font-size: 30px;
  padding: 10px;
  color: #d73f0d;
}

.surplus-mobile {
  display: none;
}

.surplus-mobile td {
  justify-content: center;
  display: flex;
}

.more-btn {
  background: $orange;
  color: #fff;
  padding: 10px 15px;
  font-size: 16px;
  transition: background 0.2s ease-in-out;
  border-radius: 3px;
  &:hover {
    background: $lightOrange;
    text-decoration: none;
  }
}

@media screen and (max-width: 767px) {
  .report-template .section-title {
    font-size: 26px;
  }

  .report-template .sub-title {
    font-size: 22px;
  }

  .surplus {
    display: none;
  }

  .surplus-mobile {
    display: block;
  }
}
</style>